<template>
  <div class="sidebar">
    <div class="links">
      <router-link :to="link.to" class="linkMenu" :class="{active: getRoute === link.name || getRoute === link.child}" v-for="(link, i) in links" :key="i">
        {{ link.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getRoute () {
      return this.$route.name
    }
  },
  data () {
    return {
      links: [
        { title: 'Баннер', name: 'Home', to: '/', child: null },
        { title: 'Гайды', name: 'Guides', to: '/guides', child: null },
        { title: 'Промокоды', name: 'Promos', to: '/promo', child: null },
        { title: 'Промокоды 15-30%', name: 'PromosCustom', to: '/promo15-30', child: null },
        { title: 'Статистика', name: 'Dashboard', to: '/dashboard', child: null },
        { title: 'Емейлы', name: 'Emails', to: '/emails', child: null },
        { title: 'Юзеры', name: 'Emails', to: '/users', child: null },
        { title: 'Подарки', name: 'Transaction', to: '/transaction', child: null },
        { title: 'Модальное окно', name: 'Modal', to: '/modal', child: null },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar{
  @include box(15%, 100%, relative, 0, 0, null, null, 0, $sidebar);
  @include padding(0, 2vw, 0, 2vw);
  @include flex(left, top, column);
  overflow: hidden;
  .links{
    @include size(100%, null);
    @include flex(left, top, column);
    @include border(null, solid, $sidebarBorder, null, 0.04vw, null, null);
    .linkMenu{
      @include box(100%, 3vw, relative, null, null, null, null, null, null);
      @include padding(2vw, 0, 2vw, 0);
      @include flex(left, center, row);
      @include border(null, solid, $sidebarBorder, null, null, null, 0.04vw);
      @include text(0.9vw, 400, 0.06vw, null, left, $sidebarLinkColor);
      cursor: pointer;
      &:after{
        content: '';
        @include box(0.5vw, 0.5vw, absolute, null, null, 2vw, null, 50%, $sidebarLinkArrow);
        opacity: 0;
        transition: 0.3s;
      }
      &:hover{
        @include box(null, null, null, null, null, null, null, null, $sidebarLinkHover);
        @include text(null, null, null, null, null, $sidebarLinkHoverColor);
      }
      &.active{
        @include box(null, null, null, null, null, null, null, null, $sidebarLinkActive);
        @include text(null, null, null, null, left, $sidebarLinkColor);
        cursor: default;
        text-indent: 0.5vw;
        &:after{
          right: 1vw;
          opacity: 1;
        }
      }
    }
  }
}
</style>
